import { Loader2 } from "lucide-react";

/**
 * Fallback affiché pendant le chargement d'une route lazy-loaded.
 *
 * Volontairement sobre (spinner centré) pour ne pas paraître plus lourd
 * que la page elle-même. La plupart des routes se chargent en < 200ms
 * sur connexion correcte.
 */
export function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      lang="fr"
      className="grid min-h-[60vh] place-items-center"
    >
      <div className="flex flex-col items-center gap-3 text-ink-muted">
        <Loader2 aria-hidden="true" className="size-6 animate-spin" />
        <span className="text-xs">Chargement…</span>
      </div>
    </div>
  );
}
